import React, { useState } from 'react';
import tick from '../../../../image/Icons/tick-a805fb.svg';
import crossIcon from '../../../../image/Icons/Cross.svg';
import phoneImg from '../../../../image/ipad-iphone.png';
import CotalityLogo from '../../../../image/Cotality_Logo_RGB.png';
import MultiSelect from 'react-multi-select-component';
import { FormControl, Modal } from '../../compat/BootstrapCompat';
import InfoTooltip from '../../compat/InfoTooltip';

export default function StepFour(props) {
  // const [props.inputValues, setprops.inputValues] = useState(cloneDeep(props.inputValues));

  const [showUserEdit, setUserEdit] = useState(false);
  const [showGeoEdit, setGeoEdit] = useState(false);
  const [showMarketEdit, setMarketEdit] = useState(false);
  const [showReportEdit, setReportEdit] = useState(false);
  const [showNotifyEdit, setNotifyEdit] = useState(false);
  const [showExportEdit, setExportEdit] = useState(false);
  const [showDigitalProposalsEdit, setDigitalProposalsEdit] = useState(false);

  let geographyList = props.inputValues.geography.value.map((item) => item.value);

  const couponTooltip = 'Navigate to the Cart to add or edit coupon code';
  const employeeCountTooltip = 'Number of employees requiring RP Data';
  const geographyTooltip = 'States/Territories that you service';
  const directMarketingTooltip = 'Do you want to use RP Data for direct marketing?';
  const dataReportsTooltip = 'Would you like to produce custom RP Data reports branded with your logo, colours and contract details?';
  const notifyTooltip = 'Do you need to be instantly notified about changes in your local market?';
  const dataExportsTooltip = 'Would you like the ability to export property data and attributes for offline analysis and filtering?';
  const digitalProposalsTooltip = 'Would you like to create branded, interactive and customisable digital listing kits, pre-list kits and rental proposals or create interactive digital property reports for your clients?';

  /* istanbul ignore next */
  function handleViewAllFeatures() {
    props.trackStep('View All Features', props.currentStep);
    props.setModal(true);
  }

  /* istanbul ignore next */
  function handleUserEdit() {
    props.trackHmcwEdit('Edit Selection', null, 'employeeCount', null);
    props.cancelChange('employeeCount');
    setUserEdit(!showUserEdit);
  }

  /* istanbul ignore next */
  function handleGeoEdit() {
    props.trackHmcwEdit('Edit Selection', null, 'geography', null);
    props.cancelChange('geography');
    setGeoEdit(!showGeoEdit);
  }

  /* istanbul ignore next */
  function pricingFormat(value) {
    let parts = value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  /* istanbul ignore next */
  function checkProductCoupon() {
    let productId = props.product.productsConfig[props.FRIENDLY_NAME].id;
    let ids = props.coupon.productIds;
    if (ids !== null) {
      for (let id = 0; id < ids.length; id++) {
        if (parseInt(ids[id], 10) === productId) {
          return true;
        }
      }
      return false;
    } else {
      return true;
    }
  }

  function renderInputValuesCheckIcon(isFeatureChecked) {
    return (
      isFeatureChecked ===  'Yes' ?
      <img src={tick} alt='yes' className='margin-right-5 tick-margin' />
      :<img src={crossIcon} alt='' className='margin-right-5 margin-left-5 padding-right-5' style={{marginTop: '-3px'}} />
    )

  }

  function renderTooltipIcon(tooltipText, iconStyle) {
    return (
      <InfoTooltip text={tooltipText}>
        <span>
          <i className='far fa-question-circle tooltip-icon-new' aria-hidden='true' style={iconStyle}></i>
        </span>
      </InfoTooltip>
    );
  }

  const ArrowRenderer = () => <>{ <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>}</>;
  return (
    <React.Fragment>
      <div className='padding-30-0 text-center hmcw-h3'  style={{textAlign:'left'}}>
        Our recommended RP Data package for you
      </div>
      <div className='row margin-bottom-20'>
        <div className='col-sm-6 recommended-package-card'>
          <div className='text-center'>
            <img src={CotalityLogo} alt='Cotality' className='padding-10 package-icon' />
          </div>
          {!props.productLoading && (
            <div>
              <p className='text-uppercase no-margin package-title text-center hmcw-h5'>
                {props.productConfiguration.package}
              </p>
              <p className='blue-text no-margin text-center body'>
                ({props.productConfiguration.number_of_users} Users)
              </p>
              <p className='hmcw-h4 text-center no-margin'>
                <span className='superscript captions'>From</span> $
                {parseFloat(props.productQuote.totalPerMonth).toFixed(2)}
                <span className='captions'>/mth</span>
              </p>
              <p className='sub-text text-center margin-bottom-10 footnote-text'>
                Min. cost is $
                {pricingFormat(parseFloat(props.productQuote.totalPerMonth * 12).toFixed(2))} over{' '}
                {12} month(s).
              </p>
            </div>
          )}
          {props.productLoading && (
            <div className='row text-center margin-10'>
              <i className='fa fa-spinner fa-pulse fa-3x fa-fw'></i>
              <span className='sr-only'>Loading...</span>
            </div>
          )}
          <p className='text-center'>
            {props.productConfiguration.package === 'lite' && (
              <span className="body-semibold">Subscription Features Include:</span>
            )}
            {props.productConfiguration.package === 'base' && <span className="body-semibold">Everything in Lite plus:</span>}
            {props.productConfiguration.package === 'premium' && (
              <span className="body-semibold">Everything in Base plus:</span>
            )}
            {props.productConfiguration.package !== 'lite' && (
              <span
                className='text-link'
                onClick={handleViewAllFeatures}
              >
                &nbsp;View all Features
              </span>
            )}
          </p>
          {props.recommendedPackage.features && (
            <div className='features-package-container features-package-width-70'>
              {props.recommendedPackage.features.filteredDisplay.map((feature, featureKey) => {
                return (
                  <div className='features-package-item-100 body' key={featureKey}>
                    <img src={tick} alt='yes' className='margin-right-5' style={{marginTop:'-5px'}}/>
                    {feature.title}
                    {feature.description && (
                      renderTooltipIcon(feature.description, { top: '0.1em' })
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className='col-sm-6 wizard-selection-container'>
          <p className='body'>This package was suggested based on your selections*</p>
          <div className='features-package-container body'>
            <div className='features-package-item-100'>
      <img src={tick} alt='yes' className='margin-right-5 tick-margin' />
              {props.inputValues.employeeCount.value} RP Data users
              {showUserEdit && (
                renderTooltipIcon(employeeCountTooltip, { top: '0.1em' })
              )}
              <span
                className='float-right'
                onClick={handleUserEdit}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showUserEdit && (
                <div className='wizard-edit-container'>
                  <FormControl
                    className={
                      props.inputValues.employeeCount.error
                        ? 'form-error-border margin-bottom-5 wizard-select'
                        : 'margin-bottom-5 wizard-select'
                    }
                    name='employeeCount'
                    componentClass='select'
                    value={
                      props.inputValues.employeeCount.tempValue
                        ? props.inputValues.employeeCount.tempValue
                        : props.inputValues.employeeCount.value
                        ? props.inputValues.employeeCount.value
                        : ''
                    }
                    onChange={props.handleEditChange}
                  >
                    <option value='1'>1 user</option>
                    <option value='3'>2-3 users</option>
                    <option value='5'>4-5 users</option>
                    <option value='10'>6-10 users</option>
                    <option value='15'>11-15 users</option>
                    <option value='25'>16-25 users</option>
                  </FormControl>
                  <span style={{marginTop:'-43px'}} className='panel-dropdown-icon carat-down single-select-carat' aria-hidden='true'></span>
                  <span className='float-right'>
                    <span
                      className={
                        props.inputValues.employeeCount.error ||
                        props.inputValues.employeeCount.tempValue === null ||
                        (props.inputValues.employeeCount.tempValue &&
                          props.inputValues.employeeCount.tempValue ===
                            props.inputValues.employeeCount.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue color-aliceblue margin-right-5 border-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue '
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'employeeCount');
                        setUserEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('employeeCount');
                        setUserEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
      <img src={tick} alt='yes' className='margin-right-5 tick-margin' />
              Servicing {geographyList.join(', ')}
              {showGeoEdit && (
                renderTooltipIcon(geographyTooltip)
              )}
              <span
                className='float-right'
                onClick={handleGeoEdit}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showGeoEdit && (
                <div className='wizard-edit-container'>
                  <MultiSelect
                    className={
                      props.inputValues.geography.error
                        ? 'wizard-multiselect form-error-border margin-bottom-5'
                        : 'wizard-multiselect margin-bottom-5'
                    }
                    ArrowRenderer={ArrowRenderer}
                    name='geography'
                    options={props.geographyOptions}
                    value={
                      props.inputValues.geography.tempValue
                        ? props.inputValues.geography.tempValue
                        : props.inputValues.geography.value
                    }
                    onChange={(e) => {
                      props.handleEditChange(e, 'geography');
                    }}
                  />
                  {props.inputValues.geography.error && (
                    <div className='red-text font-10 float-left'>
                      Please select the state/territories.
                    </div>
                  )}
                  <span className='float-right'>
                    <span
                      className={
                        props.inputValues.geography.error ||
                        props.inputValues.geography.tempValue === null ||
                        (props.inputValues.geography.tempValue &&
                          JSON.stringify(props.inputValues.geography.tempValue) ===
                            JSON.stringify(props.inputValues.geography.value))
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'geography');
                        if (!props.inputValues.geography.error) {
                          setGeoEdit(false);
                        }
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('geography');
                        setGeoEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
              {renderInputValuesCheckIcon(props.inputValues.directMarketing.value)}
              Marketing Direct
              {showMarketEdit && (
                renderTooltipIcon(directMarketingTooltip)
              )}
              <span
                className='float-right'
                onClick={() => {
                  props.trackHmcwEdit('Edit Selection', null, 'directMarketing', null);
                  props.cancelChange('directMarketing');
                  setMarketEdit(!showMarketEdit);
                }}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showMarketEdit && (
                <div className='wizard-edit-container'>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='directMarketing'
                        value='Yes'
                        checked={
                          props.inputValues.directMarketing.tempValue &&
                          props.inputValues.directMarketing.tempValue === 'Yes'
                            ? true
                            : props.inputValues.directMarketing.tempValue === null &&
                              props.inputValues.directMarketing.value === 'Yes'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      Yes
                    </label>
                  </div>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='directMarketing'
                        value='No'
                        checked={
                          props.inputValues.directMarketing.tempValue &&
                          props.inputValues.directMarketing.tempValue === 'No'
                            ? true
                            : props.inputValues.directMarketing.tempValue === null &&
                              props.inputValues.directMarketing.value === 'No'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      No
                    </label>
                  </div>
                  <span className='float-right margin-top-5'>
                    <span
                      className={
                        props.inputValues.directMarketing.error ||
                        props.inputValues.directMarketing.tempValue === null ||
                        (props.inputValues.directMarketing.tempValue &&
                          props.inputValues.directMarketing.tempValue ===
                            props.inputValues.directMarketing.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'directMarketing');
                        setMarketEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('directMarketing');
                        setMarketEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
              {renderInputValuesCheckIcon(props.inputValues.dataReports.value)}
              Branded Reports
              {showReportEdit && (
                renderTooltipIcon(dataReportsTooltip)
              )}
              <span
                className='float-right'
                onClick={() => {
                  props.trackHmcwEdit('Edit Selection', null, 'dataReports', null);
                  props.cancelChange('dataReports');
                  setReportEdit(!showReportEdit);
                }}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showReportEdit && (
                <div className='wizard-edit-container'>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='dataReports'
                        value='Yes'
                        checked={
                          props.inputValues.dataReports.tempValue &&
                          props.inputValues.dataReports.tempValue === 'Yes'
                            ? true
                            : props.inputValues.dataReports.tempValue === null &&
                              props.inputValues.dataReports.value === 'Yes'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      Yes
                    </label>
                  </div>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='dataReports'
                        value='No'
                        checked={
                          props.inputValues.dataReports.tempValue &&
                          props.inputValues.dataReports.tempValue === 'No'
                            ? true
                            : props.inputValues.dataReports.tempValue === null &&
                              props.inputValues.dataReports.value === 'No'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      No
                    </label>
                  </div>
                  <span className='float-right margin-top-5'>
                    <span
                      className={
                        props.inputValues.dataReports.error ||
                        props.inputValues.dataReports.tempValue === null ||
                        (props.inputValues.dataReports.tempValue &&
                          props.inputValues.dataReports.tempValue ===
                            props.inputValues.dataReports.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'dataReports');
                        setReportEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('dataReports');
                        setReportEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
              {renderInputValuesCheckIcon(props.inputValues.notify.value)}
              Notifications
              {showNotifyEdit && (
                renderTooltipIcon(notifyTooltip)
              )}
              <span
                className='float-right'
                onClick={() => {
                  props.trackHmcwEdit('Edit Selection', null, 'notify', null);
                  props.cancelChange('notify');
                  setNotifyEdit(!showNotifyEdit);
                }}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showNotifyEdit && (
                <div className='wizard-edit-container'>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='notify'
                        value='Yes'
                        checked={
                          props.inputValues.notify.tempValue &&
                          props.inputValues.notify.tempValue === 'Yes'
                            ? true
                            : props.inputValues.notify.tempValue === null &&
                              props.inputValues.notify.value === 'Yes'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      Yes
                    </label>
                  </div>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='notify'
                        value='No'
                        checked={
                          props.inputValues.notify.tempValue &&
                          props.inputValues.notify.tempValue === 'No'
                            ? true
                            : props.inputValues.notify.tempValue === null &&
                              props.inputValues.notify.value === 'No'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      No
                    </label>
                  </div>
                  <span className='float-right margin-top-5'>
                    <span
                      className={
                        props.inputValues.notify.error ||
                        props.inputValues.notify.tempValue === null ||
                        (props.inputValues.notify.tempValue &&
                          props.inputValues.notify.tempValue === props.inputValues.notify.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'notify');
                        setNotifyEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('notify');
                        setNotifyEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
              {renderInputValuesCheckIcon(props.inputValues.dataExports.value)}
              Export
              {showExportEdit && (
                renderTooltipIcon(dataExportsTooltip)
              )}
              <span
                className='float-right'
                onClick={() => {
                  props.trackHmcwEdit('Edit Selection', null, 'dataExports', null);
                  props.cancelChange('dataExports');
                  setExportEdit(!showExportEdit);
                }}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showExportEdit && (
                <div className='wizard-edit-container'>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='dataExports'
                        value='Yes'
                        checked={
                          props.inputValues.dataExports.tempValue &&
                          props.inputValues.dataExports.tempValue === 'Yes'
                            ? true
                            : props.inputValues.dataExports.tempValue === null &&
                              props.inputValues.dataExports.value === 'Yes'
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          props.handleEditChange(e);
                        }}
                      />
                      Yes
                    </label>
                  </div>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='dataExports'
                        value='No'
                        checked={
                          props.inputValues.dataExports.tempValue &&
                          props.inputValues.dataExports.tempValue === 'No'
                            ? true
                            : props.inputValues.dataExports.tempValue === null &&
                              props.inputValues.dataExports.value === 'No'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      No
                    </label>
                  </div>
                  <span className='float-right margin-top-5'>
                    <span
                      className={
                        props.inputValues.dataExports.error ||
                        props.inputValues.dataExports.tempValue === null ||
                        (props.inputValues.dataExports.tempValue &&
                          props.inputValues.dataExports.tempValue ===
                            props.inputValues.dataExports.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'dataExports');
                        setExportEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('dataExports');
                        setExportEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
            <div className='features-package-item-100'>
              {renderInputValuesCheckIcon(props.inputValues.digitalProposals.value)}
              Digital Proposals & Reports
              {showDigitalProposalsEdit && (
                renderTooltipIcon(digitalProposalsTooltip)
              )}
              <span
                className='float-right'
                onClick={() => {
                  props.trackHmcwEdit('Edit Selection', null, 'digitalProposals', null);
                  props.cancelChange('digitalProposals');
                  setDigitalProposalsEdit(!showDigitalProposalsEdit);
                }}
              >
                <i className='fa fa-pencil-alt' aria-hidden='true'></i>
              </span>
              {showDigitalProposalsEdit && (
                <div className='wizard-edit-container'>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='digitalProposals'
                        value='Yes'
                        checked={
                          props.inputValues.digitalProposals.tempValue &&
                          props.inputValues.digitalProposals.tempValue === 'Yes'
                            ? true
                            : props.inputValues.digitalProposals.tempValue === null &&
                              props.inputValues.digitalProposals.value === 'Yes'
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          props.handleEditChange(e);
                        }}
                      />
                      Yes
                    </label>
                  </div>
                  <div className='col-xs-6'>
                    <label className='wizard-form-radio'>
                      <input
                        className='margin-right-5'
                        type='radio'
                        name='digitalProposals'
                        value='No'
                        checked={
                          props.inputValues.digitalProposals.tempValue &&
                          props.inputValues.digitalProposals.tempValue === 'No'
                            ? true
                            : props.inputValues.digitalProposals.tempValue === null &&
                              props.inputValues.digitalProposals.value === 'No'
                            ? true
                            : false
                        }
                        onChange={props.handleEditChange}
                      />
                      No
                    </label>
                  </div>
                  <span className='float-right margin-top-5'>
                    <span
                      className={
                        props.inputValues.digitalProposals.error ||
                        props.inputValues.digitalProposals.tempValue === null ||
                        (props.inputValues.digitalProposals.tempValue &&
                          props.inputValues.digitalProposals.tempValue ===
                            props.inputValues.digitalProposals.value)
                          ? 'disabled fa-stack fa-1x background-light-midnightblue margin-right-5 color-aliceblue'
                          : 'fa-stack fa-1x background-midnightblue margin-right-5 color-aliceblue'
                      }
                      onClick={(e) => {
                        props.saveChange(e, 'digitalProposals');
                        setDigitalProposalsEdit(false);
                      }}
                    >
                      <i className='fa fa-check fa-stack-1x'></i>
                    </span>
                    <span
                      className='fa-stack fa-1x border-midnightblue color-midnightblue'
                      onClick={(e) => {
                        props.cancelChange('digitalProposals');
                        setDigitalProposalsEdit(false);
                      }}
                    >
                      <i className='fa fa-times fa-stack-1x'></i>
                    </span>
                  </span>
                </div>
              )}
            </div>
          </div>
          {props.coupon && checkProductCoupon() && props.coupon.blueBoxText !== null && (
            <div>
              <hr />
              {props.coupon.blueBoxText}
              {renderTooltipIcon(couponTooltip, { zIndex: '0' })}
            </div>
          )}
          <hr />
          <div className='flex-centred'>
            <img src={phoneImg} className='phone-image margin-right-5' />
            <div className='body-semibold'>
              The RP Data Pro mobile app is available on iOS and Android at no additional cost.
            </div>
          </div>
        </div>
      </div>
      <div id='modal-features'>
        <Modal
          className='modal-features'
          show={props.showModal}
          onHide={() => props.setModal(false)}
        >
          <Modal.Body>
            <div className='heading3 padding-15-0'>
              {props.productConfiguration.package === 'base' && <span>Lite and Base Features</span>}
              {props.productConfiguration.package === 'premium' && (
                <span>Lite, Base and Premium Features</span>
              )}
            </div>
            {props.recommendedPackage.features && (
              <div className='features-package-container features-package-width-50'>
                {props.recommendedPackage.features.display.map((feature, featureKey) => {
                  return (
                    <div className='features-package-item-100' key={featureKey}>
                      <img src={tick} alt='yes' className='margin-right-5' />
                      {feature.title}
                      {feature.description && (
                        renderTooltipIcon(feature.description)
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            <div className='padding-15-0'>
              <button
                className='btn btn-primary features-modal-close-btn'
                type='button'
                onClick={() => {
                  props.trackStep('Close View All Features', props.currentStep);
                  props.setModal(false);
                }}
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </React.Fragment>
  );
}
